export default {
    template: `<div><slot v-bind="self" /></div>`,
    data() {
        return {}
    },
    computed: {
        self() {
            return this;
        },
    },
}
